import script from "./protocolsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./protocolsModal.vue?vue&type=script&setup=true&lang=ts"

import "./protocolsModal.vue?vue&type=style&index=0&id=7c354de0&scoped=true&lang=scss"
script.__scopeId = "data-v-7c354de0"

export default script